import {SpaceTr, Tr} from "@/i18n/i18n";
import {VerticalStandardPanel} from "@/scenes.ui/vertical-standard-panel";
import Scene = Phaser.Scene;
import TextUtils from "@/utils/text-utils";
import {Fonts} from "@/constants/font";
import {Keys} from "@/constants/key";
import {TurnPlace} from "@/store/place/types";
import BaseSound = Phaser.Sound.BaseSound;
import AtlasUtils from "@/utils/atlas-utils";
import SpriteUtils from "@/utils/sprite-utils";

export class PlaceCreaturePanel extends VerticalStandardPanel {

    private onAcceptCallback: (() => unknown) | undefined;
    private closeSound: BaseSound | undefined;

    constructor(scene: Scene, canvas: HTMLCanvasElement, p: TurnPlace, closeSound: BaseSound | undefined, onAcceptCallback: () => unknown) {
        super(scene, canvas, Tr('povorot'));

        this.closeSound = closeSound;
        this.onAcceptCallback = onAcceptCallback;

        let nameText = TextUtils.addTextByFamily(scene, p.creatureNamePlural!.toUpperCase(), 0, -190,
            '#ffd465', 16, 'bold', 450, Fonts.MYRIADPRO_BOLD);

        let light = SpriteUtils.addSprite(this.scene, 0, -120, Keys.ATLAS_PROFILE, Keys.UI_ART_LIGHT);
        let icon = SpriteUtils.addSprite(this.scene, 0, -120, AtlasUtils.getCreatureRoadAtlas(p.creatureId), p.creatureId!);

        let consEffectText = TextUtils.addTextByFamily(scene, String(p.creatureLevel) + SpaceTr('y.uroven').toUpperCase(),
            0, icon.y + 60,'#e0e0e0', 13, 'normal', 450, Fonts.ARIAL_MT);

        let infoText = TextUtils.addTextAdvanced(scene, p.comment.toUpperCase() + Tr('dot.no.povorot.zaschischajut') + p.creatureNamePlural!.toUpperCase() + '.',
            consEffectText.x, consEffectText.y + 70,
            '#716f6a', 12, 'normal', 450, 'center', 2, Fonts.ARIAL_MT);

        this.add([nameText, light, icon, consEffectText, infoText]);

        this.addButton(Tr('v.boy'), Keys.UI_ART_GREEN_BUTTON, Keys.ATLAS_PROFILE, Keys.IMG_ATTACK, onAcceptCallback);
    }

    protected onClose(): void {

    }

}
